import { DateFormat } from '@brighterly/lib-core-types/date/enums'

import { useDayjs } from '@shared/lib/format'

import { useLessonEditStore } from './edit/store'

interface LessonConnectionField {
  id: string
  label: string
  value: string
}

interface LessonConnectionReturn {
  refFields: ComputedRef<LessonConnectionField[]>
  refHasStatus: ComputedRef<boolean>
}

const EMPTY = '-'

/** When each side of the lesson came in, and whether they were late — read-only, as in the legacy tab. */
export const useLessonConnection = (): LessonConnectionReturn => {
  const dayjs = useDayjs()
  const store = useLessonEditStore()

  const formatDelay = (value: boolean | null): string => (value === null ? EMPTY : String(value))

  const formatTime = (value: string | null): string =>
    value ? dayjs(value, DateFormat.Default).format(DateFormat.KanbanDate) : EMPTY

  const refHasStatus = computed<boolean>(() => !!store.getLesson?.connection_status)

  const refFields = computed<LessonConnectionField[]>(() => {
    const status = store.getLesson?.connection_status
    if (!status) return []

    return [
      { id: 'tutor-delay', label: 'Tutor delay:', value: formatDelay(status.tutor_delay) },
      { id: 'customer-delay', label: 'Customer delay:', value: formatDelay(status.customer_delay) },
      { id: 'tutor-connect', label: 'Tutor Check In:', value: formatTime(status.tutor_connect) },
      { id: 'customer-connect', label: 'Customer connect:', value: formatTime(status.customer_connect) },
    ]
  })

  return {
    refFields,
    refHasStatus,
  }
}
